import { CampaignType } from 'apis/restaurant-api/merchant-admin/campaigns/types';
import {
  CampaignType as AvoCampaignType,
  OptionSelected,
  OptionSelectedValueType,
  TargetContentCampaignEdit,
  TargetContentCampaignsTableValueType,
  TargetContentDatePicker,
  TargetContentDatePickerValueType,
  TargetContentNewCampaigns,
} from 'core/telemetry/avo/Avo';

import { CampaignColumnIds } from '../../components/CampaignTable/types';
import { Period } from '../../components/analytics/FilterDateRangePicker';

export const CampaignTypeToAvoCampaignTypeMap = {
  [CampaignType.BASKET_DISCOUNT]: AvoCampaignType.BASKET_DISCOUNT,
  [CampaignType.ADS]: AvoCampaignType.ADS,
  [CampaignType.DELIVERY_DISCOUNT]: AvoCampaignType.FREE_DELIVERY,
  [CampaignType.ITEM_DISCOUNT]: AvoCampaignType.ITEM_DISCOUNT,
  [CampaignType.END_OF_DAY]: AvoCampaignType.END_OF_DAY,
};

export const campaignTypeToAvoOptionSelectedMap: { [key in CampaignType]: OptionSelectedValueType } = {
  [CampaignType.DELIVERY_DISCOUNT]: OptionSelected.FREE_DELIVERY,
  [CampaignType.BASKET_DISCOUNT]: OptionSelected.BASKET_DISCOUNT,
  [CampaignType.ADS]: OptionSelected.ADS,
  [CampaignType.ITEM_DISCOUNT]: OptionSelected.ITEM_DISCOUNT,
  [CampaignType.END_OF_DAY]: OptionSelected.END_OF_DAY,
};

export const columnIdToTargetContentMap: { [key in CampaignColumnIds]?: TargetContentCampaignsTableValueType } = {
  [CampaignColumnIds.START_DATE]: 'start',
  [CampaignColumnIds.END_DATE]: 'end',
  [CampaignColumnIds.CAMPAIGN_TYPE]: 'type',
  [CampaignColumnIds.CAMPAIGN_STATUS]: 'status',
};

export const CampaignsTargetContent = {
  EDIT: {
    CHANGE_RULES: TargetContentCampaignEdit.CHANGE_RULES,
    CHANGE_SPEND: TargetContentCampaignEdit.CHANGE_SPEND,
    CHANGE_SCHEDULING: TargetContentCampaignEdit.CHANGE_SCHEDULING,
    CHANGE_DISCOUNT: TargetContentCampaignEdit.CHANGE_DISCOUNT,
    CHANGE_UPPER_LIMIT: TargetContentCampaignEdit.CHANGE_UPPER_LIMIT,
    BASKET_DISCOUNT_TYPE: TargetContentCampaignEdit.BASKET_DISCOUNT_TYPE,
  },
  NEW: {
    TOOLTIP_HELP_DISMISSED: TargetContentNewCampaigns.TOOLTIP_HELP_DISMISSED,
    CAMPAIGN_NAME: TargetContentNewCampaigns.CAMPAIGN_NAME,
    CHANGE_RULES: TargetContentNewCampaigns.CHANGE_RULES,
    SELECTION_MINIMUM_RANGE: TargetContentNewCampaigns.SELECTION_MINIMUM_RANGE,
    SELECTION_MEDIUM_RANGE: TargetContentNewCampaigns.SELECTION_MEDIUM_RANGE,
    CHANGE_SCHEDULING: TargetContentNewCampaigns.CHANGE_SCHEDULING,
    CREATE_CAMPAIGN: TargetContentNewCampaigns.CREATE_CAMPAIGN,
    CHANGE_DISCOUNT: TargetContentNewCampaigns.CHANGE_DISCOUNT,
    CHANGE_UPPER_LIMIT: TargetContentNewCampaigns.CHANGE_UPPER_LIMIT,
    BASKET_DISCOUNT_TYPE: TargetContentNewCampaigns.BASKET_DISCOUNT_TYPE,
  },
};

export const periodToAvoPeriodMap: { [key in Period]: TargetContentDatePickerValueType } = {
  yesterday: TargetContentDatePicker.DATE_PICKER_YESTERDAY,
  'this-week': TargetContentDatePicker.DATE_PICKER_THIS_WEEK,
  'last-week': TargetContentDatePicker.DATE_PICKER_LAST_WEEK,
  'last-28-days': TargetContentDatePicker.DATE_PICKER_LAST_28_DAYS,
};
